<template>
    <v-input :rules="field.rules" :value="value">
        <v-card class="pa-3" width="100%">
            <v-container>
                <v-row>
                    <v-col
                        v-for="(option, i) in options"
                        :key="i"
                        :sm="6"
                        :cols="12"
                    >
                        <v-card :elevation="2">
                            <v-card-title
                                style="font-size: 18px; font-weight: normal"
                            >
                                {{ field.elementName || "選項" }} {{ i + 1 }}
                                <v-spacer></v-spacer>
                                <v-btn icon @click="removeOption(i)"
                                    ><v-icon>mdi-close</v-icon></v-btn
                                >
                            </v-card-title>
                            <v-col
                                :cols="field.cols || 12"
                                v-for="(subfield, j) in field.subfields"
                                :key="subfield.key + j"
                            >
                                <v-text-field
                                    v-if="subfield.type === 'text-i18n'"
                                    :key="subfield.key + j"
                                    v-model="
                                        option.value[subfield.key][
                                            currentI18nKey
                                        ]
                                    "
                                    :label="subfield.name"
                                    outlined
                                    hide-details
                                >
                                </v-text-field>
                                <v-text-field
                                    v-if="subfield.type === 'text'"
                                    :key="subfield.key + j"
                                    v-model="option.value[subfield.key]"
                                    :label="subfield.name"
                                    outlined
                                    hide-details
                                >
                                </v-text-field>
                                <image-input
                                    v-if="subfield.type === 'image'"
                                    :key="subfield.key + j"
                                    v-model="option.value[subfield.key]"
                                    :field="subfield"
                                />
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row class="pa-3">
                    <v-btn @click="addOption">新增</v-btn>
                </v-row>
            </v-container>
        </v-card>
    </v-input>
</template>

<script>
import _ from 'lodash';
import i18nMixin from '@/views/mixins/i18nMixin';
import ImageInput from './ImageInput.vue';

export default {
    components: { ImageInput },
    mixins: [i18nMixin],
    props: {
        value: Array,
        field: Object,
        selectedI18n: Number,
        autoOptions: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        options() {
            return _.map(this.value, (option) => ({ value: option }));
        },
    },
    methods: {
        init() {
            // Called by parent directly
            if (this.autoOptions && _.isEmpty(this.value)) {
                this.addOption();
            }
        },
        addOption() {
            const newOption = _.chain(this.field.subfields)
                .mapKeys('key')
                .mapValues((field) => {
                    if (field.type === 'text-i18n') return this.i18nDefaultValue();
                    return null;
                })
                .value();
            this.$emit('input', this.value ? [...this.value, newOption] : [newOption]);
        },
        removeOption(i) {
            const options = _.map(this.options, 'value');
            options.splice(i, 1);
            this.$emit('input', options);
        },
        onChange() {
            const options = _.map(this.options, 'value');
            this.$emit('input', options);
        },
    },
    created() {
        this.init(); // created時還沒註冊事件，先手動觸發一次
        this.$parent.$on('init', this.init);
    },
    destroyed() {
        this.$parent.$off('init', this.init);
    },
};
</script>

<style>
</style>
